
export const Theme = {
  input: [
    'w-4 h-4 text-primary-600 border-neutral-200 rounded',
    'focus:ring-2 focus:ring-primary-500',
    'disabled:text-neutral-400 disabled:cursor-not-allowed',
    'dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600',
    'dark:focus:ring-primary-600'
  ],
  label: [
    'text-sm ml-4 text-gray-900 cursor-pointer',
    'dark:text-gray-300'
  ],
  labelDisabled: [
    'cursor-default',
    'dark:text-gray-500'
  ]
};
